import { useTranslation } from 'react-i18next'

import { EntityStatus } from '../../../../Entity'
import { APPLICANT_STAGES } from '../../../../RentalPortalApplicant'
import Text from '../../../../Text'
import { QA_NAME_APPLICANT_PROFILE_STAGE_MIRROR } from '../RentalPortalApplicantProfileWidgetStageScreening.constants'

import * as styles from './ApplicantProfileWidgetStageScreeningStage.module.css'

function ApplicantProfileWidgetStageScreeningStage({ stage }) {
  const { t } = useTranslation()

  return (
    <div className={styles.ApplicantProfileWidgetStageScreeningStage}>
      <Text isSecondary className={styles.label}>
        {t('RentalPortal.ApplicantProfileStageMirrorLabelKey')}
      </Text>
      <EntityStatus
        id={stage}
        statuses={APPLICANT_STAGES}
        textQaName={QA_NAME_APPLICANT_PROFILE_STAGE_MIRROR}
      />
    </div>
  )
}

export default ApplicantProfileWidgetStageScreeningStage
